<template>
    <div class="creat_box">
        <div class="creat_div">
            <span class="label_class">角色名称</span>
            <Input v-model="role.roleName" placeholder="输入角色名称" style="width:418px;" :readonly="$route.query.type=='look'"/>
        </div>
        <div  class="creat_div">
            <span class="label_class">角色描述</span>
            <textarea v-model="role.description" class="text_class" placeholder="输入角色描述" :readonly="$route.query.type=='look'"></textarea>
        </div>
        <div>
            <span class="label_class">权限</span>
            <div class='left_div'>
                <ul>
                    <li v-for="(item,i) in newlist" :key='i' style="margin-bottom:20px;">
                        <div style="margin-bottom:15px;">
                            <span class="quare" @click="$route.query.type=='look'?'':(item.choose=!item.choose)" style="white-space:nowrap;">
                                <span style="display:inline-block;width:3px;"></span><img src="@/assets/img/choose.png" alt=""  :class="item.choose?'':'hidden'">
                            </span>
                            <span style="color: #101d37;font-weight:700;cursor: pointer;" @click="$route.query.type=='look'?'':(item.choose=!item.choose)">
                                {{item.componentName}}
                            </span>
                        </div>
                        <div>
                            <div v-for="(child,index) in item.children" :key='index' style="display:inline-block;margin-bottom:15px;">
                                
                                <span class="quare" @click="$route.query.type=='look'?'':(child.choose=!child.choose)" style="white-space:nowrap;">
                                    <span style="display:inline-block;width:3px;"></span><img src="@/assets/img/choose.png" alt=""  :class="child.choose?'':'hidden'">
                                </span>
                                <span style="min-width:130px;display:inline-block;color: #101d37;cursor: pointer;"  @click="$route.query.type=='look'?'':(child.choose=!child.choose)">
                                    {{child.componentName}}
                                </span>
                            </div>

                        </div>
                    </li>
                </ul>
                <button class="btn_class submit" @click="submit" v-if="$route.query.type!=='look'">保存</button>
            </div>
        </div>
    </div>
</template>

<script>
import {menulist} from '@/api/axios'
import { admin } from '@/api/admin'
export default {
  name: 'roleCreat',
  props: {
    msg: String
  },
  data(){
    return{
        role:{
            roleName: "",
            description: "",
        },
        btnclick:true,
        name:'',
        descript:'',
        qxlist:[],
        permissionIds:[],
        defaultid:[],
        user:[
            {
                name:'经纪人',
                id:1,
                choose:false,
                child:[
                    {
                        name:'在售房源',
                        id:'101',
                        choose:false,
                    },
                    {
                        name:'在售房源',
                        id:'101',
                        choose:false,
                    },
                    {
                        name:'实勘任务列表',
                        id:'101',
                        choose:false,
                    },{
                        name:'在售房源',
                        id:'101',
                        choose:false,
                    },{
                        name:'在售房源',
                        id:'101',
                        choose:false,
                    },
                    {
                        name:'在售房源',
                        id:'101',
                        choose:false,
                    },{
                        name:'在售房源',
                        id:'101',
                        choose:false,
                    },
                ]
            },
            {
                name:'门店店长',
                id:2,
                choose:false,
                child:[
                    {
                        name:'在售房源',
                        id:'101',
                        choose:false,
                    },
                    {
                        name:'在售房源',
                        id:'101',
                        choose:false,
                    },
                    {
                        name:'在售房源',
                        id:'101',
                        choose:false,
                    },{
                        name:'在售房源',
                        id:'101',
                        choose:false,
                    },{
                        name:'门店经纪人房源数据审核',
                        id:'101',
                        choose:false,
                    },
                ]
            },

        ]
    }
  },
  mounted(){
      if(this.$route.query.id){
          this.getinfor();
      }else{
          this.getqxlist();
      }
  },
  computed:{
      newlist(){
          let arr=[];
          if(this.qxlist.length==0){
              return  [];
          }
          for(var i=0;i<this.qxlist.length;i++){
                arr[i]={};
                this.$set(this.qxlist[i],'choose',false);
                // this.qxlist[i].choose=false;
                arr[i]=this.qxlist[i];
                if(this.qxlist[i].isLeaf=='0'){
                    for(var j=0;j<this.qxlist[i].children.length;j++){
                        this.$set(this.qxlist[i].children[j],'choose',false);
                        
                        if(this.qxlist[i].children[j].isLeaf=='0'){
                            for(var k=0;k<this.qxlist[i].children[j].children.length;k++){
                                this.$set(this.qxlist[i].children[j].children[k],'choose',false);
                                // this.qxlist[i].children[j].children[k].choose=false;
                            }
                            arr[i].children=[...arr[i].children,...arr[i].children[j].children];
                        }
                    }
                }
          }
            for(var m =0; m<this.defaultid.length;m++){
                for(var k=0;k<arr.length;k++){
                    if(this.defaultid[m]==arr[k].permissionId){
                        this.$set(arr[k],'choose',true);
                    }
                    if(arr[k].isLeaf=='0'){
                        for(var j=0;j<arr[k].children.length;j++){
                            if(this.defaultid[m]==arr[k].children[j].permissionId){
                                this.$set(arr[k].children[j],'choose',true);
                            }
                        }    
                    }    
                }
                        
            }
          return arr;
      }
  },
  methods:{
        getqxlist(){
            menulist().then(res=>{
                if(res.data.success==true){
                    this.qxlist=res.data.result;
                }
            })
        },
        getinfor(){
            admin.getroleInfor(this.$route.query.id).then(res=>{
                if(res.data.success==true){
                    this.role.roleName=res.data.result.role.roleName;
                    this.role.roleId=res.data.result.role.roleId;
                    this.role.description=res.data.result.role.description;
                    this.defaultid=res.data.result.permissionIds;
                    this.getqxlist();
                }
            })
        },
        submit(){
            if(!this.btnclick){
                this.$Message.error('已提交，请稍候');
                return;
            }
            this.permissionIds=[];
            for(var i=0;i<this.newlist.length;i++){
                if(this.newlist[i].choose==true){
                    this.permissionIds.push(this.newlist[i].permissionId);
                }
                if(this.newlist[i].isLeaf=='0'){
                    for(var j=0;j<this.newlist[i].children.length;j++){
                        if(this.newlist[i].children[j].choose==true){
                            this.permissionIds.push(this.newlist[i].children[j].permissionId);
                        }
                    }
                }
            }
            if(!this.role.roleName){
                this.$Message.error('请填写用户角色');
                return;
            }
            if(this.role.roleName.length>20){
                this.$Message.error('角色不能超过20个字');
                return;
            }
            if(!this.role.description){
                this.$Message.error('请填写用户角色描述');
                return;
            }
            if(this.role.description.length>100){
                this.$Message.error('角色描述不能超过100个字');
                return;
            }
            if(this.permissionIds.length==0){
                this.$Message.error('请选择权限');
                return;
            }
            this.btnclick=false;
            if(this.$route.query.id){
                admin.editrole(this.role,this.permissionIds).then(res=>{
                    this.btnclick=true;
                    if(res.data.success==true){
                        
                        this.$router.go(-1);
                    }else{
                        this.$Message.error(res.data.message);
                    }
                });
            }else{
                this.role.roleCode='custom';
                admin.addrole(this.role,this.permissionIds).then(res=>{
                    this.btnclick=true;
                    if(res.data.success==true){
                        
                        this.$router.go(-1);
                    }else{
                        this.$Message.error(res.data.message);
                    }
                });
            }
            
        }
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.creat_box{
    padding-left: 280px;
    padding-top: 40px;
}
.label_class{
    display: inline-block;
    width: 70px;
    color: #101d37;
}
.creat_div{
    margin-bottom: 25px;
}
.text_class{
    width: 418px;
    height: 192px;
    border-radius: 4px;
    border: solid 1px #dcdee2;
    padding: 7px 4px;
    vertical-align: text-top;
}
textarea::-webkit-input-placeholder {
    color:#c5c5c5;
}
textarea:-moz-placeholder {
    color:#c5c5c5;
}
textarea:-ms-input-placeholder {
    color:#c5c5c5;
}
.left_div{
    display: inline-block;
    width:calc(100% - 70px);
    vertical-align: text-top;

}
.left_div span{
    vertical-align: middle;
}
.quare{
    display: inline-block;
    width: 14px;
	height: 14px;
	border-radius: 2px;
    border: solid 1px #d9d9d9;
    margin-right:20px;
    cursor: pointer;
}
.quare img{
    width: 100%;
}
.hidden{
    display: none;
}
.submit{
    margin-top: 50px;
    margin-left: 30px;
    margin-bottom: 30px;
}
</style>
